import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import StarIcon from '@material-ui/icons/Star';
const useStyles = makeStyles((theme) => ({
    root: {
        color: '#ccc'
    },
    star: {
        color: '#fde22d',
    },
}), { name: 'HotelRecommendations' });
export default function Rating(props) {
    const classes = useStyles();
    const stars = [];
    for (let i = 0; i < props.rating; ++i) {
        stars.push(React.createElement(StarIcon, { className: classes.star, key: i, viewBox: "4 2 20 22", fontSize: props.fontSize }));
    }
    return React.createElement("span", { className: classes.root }, stars);
}
